// extracted by mini-css-extract-plugin
export default {"navigation":"PageNavigation_navigation__WBQY9"};